import React from 'react';
import { Box, Button, Text } from '@nimbus-ds/components';
import AppLayout from 'App/components/AppLayout';
import { useTranslationWithPrefix } from 'commons/utils';
import BalanceCard from '../components/BalanceCard';
import BankAccount from '../components/BankAccount';

function TransferSkeleton(): JSX.Element {
  const { t } = useTranslationWithPrefix('transfer');

  return (
    <AppLayout
      backLinkText={t('nuvemshopPanel')}
      title={t('title')}
      subtitle={t('subtitle')}
      footer={<Button.Skeleton />}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="stretch"
        justifyContent="flex-end"
        gap="4"
      >
        <BalanceCard.Skeleton />
        <Text.Skeleton />
        <BankAccount.Skeleton />
      </Box>
    </AppLayout>
  );
}

export default TransferSkeleton;
